/**
 * Persistência redundante da sessão (GEN-3111 / caso Bradesco): o cookie continua
 * sendo o caminho primário, mas ambientes corporativos podem bloquear cookies POR
 * SITE (política de navegador/gateway) — a gravação via JS falha silenciosa e o
 * usuário volta ao login mesmo com token válido. O localStorage entra como
 * fallback de leitura quando o cookie não persistir.
 *
 * Regras de coerência (obrigatórias — evitam sessão-fantasma):
 * - gravar SEMPRE junto do setCookie do token;
 * - limpar SEMPRE que a sessão morrer (401 do validate, logout).
 *
 * Módulo propositalmente sem dependências: é importado tanto por api.ts quanto
 * por authClient.ts (que importa api.ts) — helpers aqui evitam ciclo de import.
 */

export const persistSessionToken = (token: string) => {
  try {
    localStorage.setItem("token", token);
  } catch {
    /* storage indisponível — segue só com cookie */
  }
};

export const readSessionFallback = (): string | null => {
  try {
    return localStorage.getItem("token");
  } catch {
    return null;
  }
};

export const clearSessionToken = () => {
  try {
    localStorage.removeItem("token");
  } catch {
    /* noop */
  }
};
